export enum ErrorType {
  Default = 'default',
  EmptyChatId = 'emptyChatId',
  NoConnection = 'noConnection',
  MessageTooLong = 'messageTooLong',
  ConnectionFailure = 'connectionFailure',
  MessageNotDelivered = 'messageNotDelivered',
  NotInitialized = 'notInitialized',
  AddToCartFailure = 'addToCartFailure',
}
